export default __webpack_public_path__ + "static/media/98bf022bdefbce34.67ddb52b720ceafaf84232d79fb019ec.svg";